// webauthn.js — hulpfuncties voor de browser-WebAuthn-API.
//
// De server stuurt opties met velden in base64url-tekst (challenge, credential-id's),
// maar navigator.credentials.create/get verwacht ArrayBuffers — en levert ze ook weer
// terug. Hier zit dat heen-en-weer-converteren geïsoleerd.

export function base64urlNaarBuffer(base64url) {
  const base64 = base64url.replace(/-/g, '+').replace(/_/g, '/');
  const padded = base64.padEnd(base64.length + (4 - (base64.length % 4)) % 4, '=');
  const binair = atob(padded);
  const bytes = new Uint8Array(binair.length);
  for (let i = 0; i < binair.length; i++) bytes[i] = binair.charCodeAt(i);
  return bytes.buffer;
}

export function bufferNaarBase64url(buffer) {
  const bytes = new Uint8Array(buffer);
  let binair = '';
  for (let i = 0; i < bytes.length; i++) binair += String.fromCharCode(bytes[i]);
  return btoa(binair).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

// Zet de server-registratieopties om naar het formaat dat navigator.credentials.create wil.
export function bereidRegistratieVoor(opties) {
  return {
    publicKey: {
      ...opties,
      challenge: base64urlNaarBuffer(opties.challenge),
      user: {
        ...opties.user,
        id: base64urlNaarBuffer(opties.user.id),
      },
      excludeCredentials: (opties.excludeCredentials || []).map((c) => ({
        ...c,
        id: base64urlNaarBuffer(c.id),
      })),
    },
  };
}

// Zet de browser-credential (na create) om naar JSON dat de server verifieert.
export function registratieNaarJson(credential) {
  const r = credential.response;
  return {
    id: credential.id,
    rawId: bufferNaarBase64url(credential.rawId),
    type: credential.type,
    response: {
      clientDataJSON: bufferNaarBase64url(r.clientDataJSON),
      attestationObject: bufferNaarBase64url(r.attestationObject),
      transports: r.getTransports ? r.getTransports() : undefined,
    },
    clientExtensionResults: credential.getClientExtensionResults ? credential.getClientExtensionResults() : {},
  };
}

// Zet de server-loginopties om naar het formaat dat navigator.credentials.get wil.
export function bereidLoginVoor(opties) {
  return {
    publicKey: {
      ...opties,
      challenge: base64urlNaarBuffer(opties.challenge),
      allowCredentials: (opties.allowCredentials || []).map((c) => ({
        ...c,
        id: base64urlNaarBuffer(c.id),
      })),
    },
  };
}

// Zet de browser-credential (na get) om naar JSON dat de server verifieert.
export function loginNaarJson(credential) {
  const r = credential.response;
  return {
    id: credential.id,
    rawId: bufferNaarBase64url(credential.rawId),
    type: credential.type,
    response: {
      clientDataJSON: bufferNaarBase64url(r.clientDataJSON),
      authenticatorData: bufferNaarBase64url(r.authenticatorData),
      signature: bufferNaarBase64url(r.signature),
      userHandle: r.userHandle ? bufferNaarBase64url(r.userHandle) : null,
    },
    clientExtensionResults: credential.getClientExtensionResults ? credential.getClientExtensionResults() : {},
  };
}

// Beschikbaar? (passkeys vereisen een veilige context en de WebAuthn-API)
export function passkeysBeschikbaar() {
  return typeof window !== 'undefined' && !!window.PublicKeyCredential;
}
